module.exports = __webpack_public_path__ + "img/home-active.319c892c.png";